/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Command_Palette_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search for a page, a room, a MAC address…" |
*
* @param {Command_Palette_PlaceholderInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const command_palette_placeholder = /** @type {((inputs?: Command_Palette_PlaceholderInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Command_Palette_PlaceholderInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Search for a page, a room, a MAC address…")
	return /** @type {LocalizedString} */ ("Rechercher une page, une pièce, une MAC…")
});